/**
 * tm-forms.js — Renderiza los formularios propios (sustituto de Powerful Form
 * Builder). Hidrata cualquier <div data-tm-form="ID"> (secciones del tema y
 * contenido de páginas), pide la config al panel y pinta un <form> con el estilo
 * configurado (preset, acento, campos, botón, etiquetas), gestiona el envío,
 * éxito/errores/redirección y anti-spam (honeypot).
 */
(function () {
  var API = (window.__tmFormsApi || 'https://orders.tiendamanilla.com').replace(/\/$/, '');
  var cache = {};

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function fieldName(f) { return f.name || f.id || 'campo'; }
  function cssEscape(s) { return String(s).replace(/(["\\\]])/g, '\\$1'); }

  // Estilo por defecto (coincide con lib/forms/types.ts defaultStyle()).
  function normStyle(s) {
    s = s || {};
    return {
      preset: s.preset || 'card',
      accent: s.accent || '#111827',
      radius: (s.radius == null ? 10 : s.radius),
      field_style: s.field_style || 'outline',
      button_style: s.button_style || 'solid',
      button_full: !!s.button_full,
      label_style: s.label_style || 'top',
    };
  }

  var FLOAT_TYPES = { text: 1, email: 1, tel: 1, number: 1, date: 1, textarea: 1 };

  // HTML de un campo. `float` = etiqueta flotante (solo aplica a textos/textarea).
  function fieldHtml(f, float) {
    var t = f.type;
    if (t === 'hidden') return '<input type="hidden" name="' + esc(fieldName(f)) + '" value="' + esc(f.defaultValue || '') + '">';
    if (t === 'heading') return '<h3 class="tm-form__heading">' + esc(f.content || '') + '</h3>';
    if (t === 'paragraph') return '<p class="tm-form__paragraph">' + esc(f.content || '') + '</p>';

    var req = f.required ? ' required' : '';
    var reqMark = f.required ? ' <span class="tm-form__req">*</span>' : '';
    var name = esc(fieldName(f));
    var help = f.help ? '<span class="tm-form__help">' + esc(f.help) + '</span>' : '';
    var wrapCls = 'tm-form__field tm-form__field--' + esc(f.width || 'full');

    // Casilla única (aceptar): etiqueta al lado.
    if (t === 'checkbox') {
      return '<div class="' + wrapCls + '"><label class="tm-form__choice"><input type="checkbox" name="' + name + '" value="yes"' + req + '><span>' + esc(f.label) + reqMark + '</span></label>' + help + '</div>';
    }
    // Grupos de opciones.
    if (t === 'radio' || t === 'checkbox_group') {
      var it = t === 'radio' ? 'radio' : 'checkbox';
      var grp = '';
      (f.options || []).forEach(function (o, i) {
        var cn = t === 'radio' ? name : name + '[]';
        grp += '<label class="tm-form__choice"><input type="' + it + '" name="' + esc(cn) + '" value="' + esc(o.value) + '"' + (t === 'radio' && i === 0 && f.required ? ' required' : '') + '><span>' + esc(o.label) + '</span></label>';
      });
      return '<div class="' + wrapCls + '"><span class="tm-form__label">' + esc(f.label) + reqMark + '</span><div class="tm-form__choices">' + grp + '</div>' + help + '</div>';
    }
    if (t === 'select') {
      var opts = '<option value="" disabled' + (f.required ? '' : '') + ' selected>' + esc(f.placeholder || 'Selecciona…') + '</option>';
      (f.options || []).forEach(function (o) { opts += '<option value="' + esc(o.value) + '">' + esc(o.label) + '</option>'; });
      return '<div class="' + wrapCls + '"><span class="tm-form__label">' + esc(f.label) + reqMark + '</span><div class="tm-form__control"><select name="' + name + '"' + req + '>' + opts + '</select></div>' + help + '</div>';
    }
    if (t === 'file') {
      return '<div class="' + wrapCls + '"><span class="tm-form__label">' + esc(f.label) + reqMark + '</span><div class="tm-form__control"><input type="file" name="' + name + '"' + req + '></div>' + help + '</div>';
    }

    // Textos / textarea (soportan etiqueta flotante).
    var htmlType = (t === 'email' || t === 'tel' || t === 'number' || t === 'date') ? t : 'text';
    var control = t === 'textarea'
      ? '<textarea name="' + name + '" rows="4" placeholder="' + (float ? ' ' : esc(f.placeholder || '')) + '"' + req + '></textarea>'
      : '<input type="' + htmlType + '" name="' + name + '" placeholder="' + (float ? ' ' : esc(f.placeholder || '')) + '"' + req + '>';

    if (float && FLOAT_TYPES[t]) {
      return '<div class="' + wrapCls + ' tm-form__field--float"><div class="tm-form__control">' + control + '<label class="tm-form__label">' + esc(f.label) + reqMark + '</label></div>' + help + '</div>';
    }
    return '<div class="' + wrapCls + '"><label class="tm-form__label">' + esc(f.label) + reqMark + '</label><div class="tm-form__control">' + control + '</div>' + help + '</div>';
  }

  function renderForm(el, cfg, base) {
    var s = cfg.settings || {};
    var st = normStyle(s.style);
    var fields = cfg.fields || [];
    var honeypot = s.honeypot !== false;
    var float = st.label_style === 'floating';

    var cls = 'tm-form'
      + ' tm-form--' + st.preset
      + ' tm-form--field-' + st.field_style
      + ' tm-form--btn-' + st.button_style
      + ' tm-form--label-' + st.label_style
      + (st.button_full ? ' tm-form--btn-full' : '');
    var styleVar = '--tm-accent:' + st.accent + ';--tm-radius:' + st.radius + 'px;';

    var html = '<form class="' + cls + '" style="' + styleVar + '" novalidate>';
    fields.forEach(function (f) { html += fieldHtml(f, float); });
    if (honeypot) html += '<div class="tm-form__hp" aria-hidden="true"><label>No rellenar<input type="text" name="tm_hp" tabindex="-1" autocomplete="off"></label></div>';
    html += '<div class="tm-form__actions"><button type="submit" class="tm-form__submit">' + esc(s.submit_text || 'Enviar') + '</button></div>';
    html += '<div class="tm-form__msg" role="status" aria-live="polite"></div>';
    html += '</form>';
    el.innerHTML = html;

    var form = el.querySelector('form');
    var msg = el.querySelector('.tm-form__msg');
    var btn = el.querySelector('.tm-form__submit');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      msg.textContent = '';
      msg.className = 'tm-form__msg';
      if (!form.checkValidity()) { form.reportValidity(); return; }

      // Grupos de casillas obligatorios (checkValidity no los cubre).
      var groupError = null;
      fields.forEach(function (f) {
        if (f.type === 'checkbox_group' && f.required && !groupError) {
          if (!form.querySelector('input[name="' + cssEscape(fieldName(f)) + '[]"]:checked')) groupError = f;
        }
      });
      if (groupError) {
        msg.className = 'tm-form__msg tm-form__msg--error';
        msg.textContent = 'Selecciona al menos una opción en "' + (groupError.label || fieldName(groupError)) + '".';
        return;
      }

      var data = {};
      fields.forEach(function (f) {
        if (f.type === 'heading' || f.type === 'paragraph') return;
        var nm = fieldName(f);
        if (f.type === 'checkbox_group') {
          var checked = form.querySelectorAll('input[name="' + cssEscape(nm) + '[]"]:checked');
          data[nm] = Array.prototype.map.call(checked, function (c) { return c.value; });
        } else if (f.type === 'radio') {
          var r = form.querySelector('input[name="' + cssEscape(nm) + '"]:checked');
          data[nm] = r ? r.value : '';
        } else if (f.type === 'checkbox') {
          var c1 = form.querySelector('input[name="' + cssEscape(nm) + '"]');
          data[nm] = c1 && c1.checked ? 'yes' : '';
        } else if (f.type === 'file') {
          var fi = form.querySelector('input[name="' + cssEscape(nm) + '"]');
          data[nm] = fi && fi.files && fi.files[0] ? fi.files[0].name : ''; // subida real: fase posterior
        } else {
          var inp = form.querySelector('[name="' + cssEscape(nm) + '"]');
          data[nm] = inp ? inp.value : '';
        }
      });
      var hpInput = form.querySelector('input[name="tm_hp"]');
      var hp = hpInput ? hpInput.value : '';

      btn.disabled = true;
      var oldLabel = btn.textContent;
      btn.classList.add('is-loading');
      btn.textContent = 'Enviando…';

      fetch(base + '/api/forms/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ form_id: cfg.id, data: data, hp: hp, meta: { page_url: location.href, referer: document.referrer } }),
      })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (res) {
          if (res && res.success) {
            if (res.redirect_url) {
              try { var u = new URL(res.redirect_url, location.origin); if (u.protocol === 'http:' || u.protocol === 'https:') { location.href = u.href; return; } } catch (_) {}
            }
            el.innerHTML = '<div class="tm-form tm-form--' + st.preset + '" style="' + styleVar + '"><div class="tm-form__success" role="status">' + esc(res.message || '¡Gracias! Hemos recibido tu mensaje.') + '</div></div>';
          } else {
            btn.disabled = false; btn.classList.remove('is-loading'); btn.textContent = oldLabel;
            msg.className = 'tm-form__msg tm-form__msg--error';
            msg.textContent = (res && res.message) || 'No se pudo enviar. Inténtalo de nuevo.';
          }
        })
        .catch(function () {
          btn.disabled = false; btn.classList.remove('is-loading'); btn.textContent = oldLabel;
          msg.className = 'tm-form__msg tm-form__msg--error';
          msg.textContent = 'Error de conexión. Inténtalo de nuevo.';
        });
    });
  }

  function hydrate(el) {
    if (el.getAttribute('data-tm-hydrated')) return;
    el.setAttribute('data-tm-hydrated', '1');
    var id = el.getAttribute('data-tm-form');
    if (!id) return;
    var base = (el.getAttribute('data-api') || API).replace(/\/$/, '');
    var cacheKey = base + '|' + id;

    var done = function (cfg) {
      if (!cfg || cfg.error) { el.innerHTML = ''; return; }
      renderForm(el, cfg, base);
    };
    if (cache[cacheKey]) { done(cache[cacheKey]); return; }
    fetch(base + '/api/forms/public/' + encodeURIComponent(id))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cfg) { cache[cacheKey] = cfg; done(cfg); })
      .catch(function () { el.innerHTML = ''; });
  }

  // ── Pop-up: cualquier elemento con data-tm-form-popup="ID" abre el formulario
  // en un modal (sustituye los popups de Powerful Form Builder, ya desinstalado).
  var POPUP_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  function ensurePopupStyles() {
    if (document.getElementById('tm-form-popup-css')) return;
    var tag = document.createElement('style');
    tag.id = 'tm-form-popup-css';
    tag.textContent =
      '.tm-form-popup{position:fixed;inset:0;z-index:100000;display:none;align-items:center;justify-content:center;padding:20px;background:rgba(0,0,0,.55)}' +
      '.tm-form-popup.is-open{display:flex}' +
      '.tm-form-popup__dialog{position:relative;width:100%;max-width:560px;max-height:90vh;overflow-y:auto;background:#fff;border-radius:12px;padding:30px 22px 22px;box-shadow:0 24px 60px rgba(0,0,0,.35)}' +
      '.tm-form-popup__close{position:absolute;top:8px;right:10px;border:0;background:none;font-size:26px;line-height:1;cursor:pointer;color:#666;padding:6px;z-index:1}' +
      '.tm-form-popup__close:hover{color:#000}' +
      'html.tm-form-popup-lock,html.tm-form-popup-lock body{overflow:hidden}' +
      '@media (max-width:600px){.tm-form-popup{padding:12px}.tm-form-popup__dialog{padding:26px 14px 14px}}';
    document.head.appendChild(tag);
  }

  function closePopup(overlay) {
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('tm-form-popup-lock');
  }

  function openPopup(id) {
    if (!POPUP_UUID.test(id || '')) return;
    ensurePopupStyles();
    var overlay = document.querySelector('.tm-form-popup[data-form="' + id + '"]');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'tm-form-popup';
      overlay.setAttribute('data-form', id);
      overlay.innerHTML =
        '<div class="tm-form-popup__dialog" role="dialog" aria-modal="true">' +
        '<button type="button" class="tm-form-popup__close" aria-label="Cerrar">&times;</button>' +
        '<div data-tm-form="' + id + '"></div>' +
        '</div>';
      document.body.appendChild(overlay);
      hydrate(overlay.querySelector('[data-tm-form]'));
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay || (e.target.closest && e.target.closest('.tm-form-popup__close'))) closePopup(overlay);
      });
    }
    overlay.classList.add('is-open');
    document.documentElement.classList.add('tm-form-popup-lock');
  }

  // Mapa de formularios antiguos de PFB (app desinstalada) → formularios propios.
  // Revive botones/divs legacy pegados en el CONTENIDO de páginas y artículos,
  // que no se pueden editar por API. data-id lleva el id numérico en base64.
  var PFB_MAP = {
    '125081': '910870f4-8abd-4bd9-846d-48d60144b4c7', // form principal de oficios → Solicitud de reforma
    '123411': '910870f4-8abd-4bd9-846d-48d60144b4c7', // 2º form de reformas → Solicitud de reforma
    '123414': '910870f4-8abd-4bd9-846d-48d60144b4c7', // reformista Madrid → Solicitud de reforma
    '114078': 'c0df5a43-b2aa-405f-ae5b-50053553b49b', // contáctanos → Contáctanos
    '93009': '385f6aa0-68e9-4a24-9c73-15a42c279dc9', // proveedores → Proveedores
  };
  var PFB_DEFAULT_POPUP = '910870f4-8abd-4bd9-846d-48d60144b4c7'; // los botones dicen "Solicita presupuesto"

  function decodePfbId(b64) {
    try { return atob(String(b64 || '').trim()).replace(/\D/g, ''); } catch (e) { return ''; }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target && e.target.closest && e.target.closest('[data-tm-form-popup]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      openPopup(trigger.getAttribute('data-tm-form-popup'));
      return;
    }
    var legacy = e.target && e.target.closest && e.target.closest('.globo-formbuilder-open');
    if (legacy) {
      e.preventDefault();
      e.stopPropagation();
      openPopup(PFB_MAP[decodePfbId(legacy.getAttribute('data-id'))] || PFB_DEFAULT_POPUP);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.tm-form-popup.is-open');
    if (open) closePopup(open);
  });

  function scan() {
    // Divs legacy de PFB incrustados en contenido: se convierten en formulario propio si hay mapeo
    Array.prototype.forEach.call(document.querySelectorAll('div.globo-formbuilder[data-id]:not([data-tm-form])'), function (el) {
      var fid = PFB_MAP[decodePfbId(el.getAttribute('data-id'))];
      if (fid) el.setAttribute('data-tm-form', fid);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-tm-form]'), hydrate);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
